export enum EnrollmentFileStatusType {
  VALIDATION_COMPLETE = 1,
  READY_FOR_AUDIT = 2,
  AUDIT_COMPLETE = 3,
  RECEIVED= 4,
  PROCESSING = 5,
  COMPLETED = 6,
  CANCELED = 7,
  KICKOUT_VALIDATION_COMPLETE = 8,
  GROUPWEB_AUDIT_COMPLETE = 10,
  Returned = 11,
}
